import { useMemo, useRef } from 'react';
import * as ReactFlow from '@xyflow/react';
import { Row, Typography } from 'antd';
import { ApartmentOutlined } from '@ant-design/icons';

import { IItemComparison } from '../../../../SimuladorInteligente/interfaces';
import BaseNodeContainer from '../../BaseNodeContainer';
import Comparison from './components/Comparison';
import AddLinkedNodeButton from '../../AddLinkedNodeButton';

const HandleComponent = ReactFlow.Handle;

export default function ComparisonNode(node: any) {
  const comparisons = node.data.comparisons as IItemComparison[] | undefined;
  const defaultHandleId = "comparison" + node.data.label + "default";

  const defaultHandleContainerRef = useRef<HTMLDivElement>(null);

  const defaultConnections = ReactFlow.useNodeConnections({
    id: node.id,
    handleId: defaultHandleId,
    handleType: "source",
  });

  const isConnectable = useMemo(() => {
    return defaultConnections.length === 0;
  }, [defaultConnections]);

  return (
    <BaseNodeContainer
      title={"Regras internas"}
      node={node}
      IconComponent={<ApartmentOutlined />}
      showDefaultSourceConnector={false}
      defaultMessages={node.defaultMessages}
      defaultInputInstructions={node.defaultInputInstructions}
    >
      <Row
        style={{
          padding: "0px 12px 4px",
          flexDirection: 'column',
        }}
      >
        {
          comparisons?.map((comparison: IItemComparison) => (comparison.title) ? (
            <Comparison
              key={comparison.id}
              comparison={comparison}
              node={node}
              onPressAddLinkedNode={node.onPressAddLinkedNode}
            />
          ) : null)
        }
        <div
          ref={defaultHandleContainerRef}
          style={{
            position: 'relative',
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 16,
          }}
        >
          <Typography.Text>Padrão</Typography.Text>

          <HandleComponent
            id={defaultHandleId}
            type="source"
            position={ReactFlow.Position.Right}
            isConnectable={isConnectable}
          />

          {
            isConnectable && (
              <AddLinkedNodeButton
                onPress={() => {
                  node.onPressAddLinkedNode?.({
                    source: node.id,
                    sourceHandle: defaultHandleId,
                    parentPosition: {
                      x: node.positionAbsoluteX,
                      y: node.positionAbsoluteY,
                    },
                    parentWidth: node.width,
                    offsetTop: defaultHandleContainerRef.current?.offsetTop,
                  })
                }}
                style={{
                  right: -50,
                }}
              />
            )
          }
        </div>
      </Row>
    </BaseNodeContainer>
  );
}